import { Injectable }       from '@angular/core';
import {
    ActivatedRouteSnapshot,
    CanActivate,
    Router,
    RouterStateSnapshot,
    UrlTree
}                           from '@angular/router';
import {
    Observable,
    Subject,
    Subscription
}                           from 'rxjs';

import { routeNames }       from '../app.routing.names';

import { BaseService }      from '@Base/';

import { 
    AuthenticationRsp,
    AuthenticationService
}                           from './authentication.service';

import { 
    User,
    UserService
}                           from './user.service';


@Injectable({
    providedIn: 'root'
})
export class BaseGuard extends BaseService implements CanActivate
{
    public static readonly returnUrlKey = 'returnUrl';

    private _checked: boolean = false;
    protected                 _user:        User;


    constructor(protected readonly Router:                Router,
                protected readonly AuthenticationService: AuthenticationService,
                protected readonly UserService:           UserService)
    {
        super();
    }


    //
    // Public methods
    //

    // Override
    public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean | UrlTree> | UrlTree
    {
        // if user in localStorage, need to send to server to validate the first time after a re-load
        if (this._user instanceof User && this._user.isValid) {
            // Valid user - if here, token not expired as user service would have informed otherwise
            return true;//this.isChecked ? true : this.processUser(this._user);
        }
        else {
            // No valid user

            console.warn("No valid user; redirecting to login page (1)");
            console.warn(this._user);

            // Here, not logged in so redirect to login page with the return url

            // Don't do direct navigation as this causes routing errors as previous navigation which trigger
            // this guard is still incomplete.  Return urlTree instead
            //this.Router.navigate([routeNames.login], { queryParams: { returnUrl: state.url }});
            return this.Router.createUrlTree([routeNames.login], { queryParams: { returnUrl: state.url }});
        }
    }


    //
    // Private methods
    //
    private processUser(u: User): boolean | Observable<boolean | UrlTree>
    {
        // Need to check login with server
        if (this.AuthenticationService && this.AuthenticationService.login instanceof Function) {
            const obs: Observable<AuthenticationRsp> | undefined = this.AuthenticationService.login(u);
            if (obs instanceof Observable) {
                const success$: Subject<boolean | UrlTree> = new Subject<boolean | UrlTree>();
                this.sub = obs.subscribe((d: AuthenticationRsp): void => {
                    success$.next(
                        d && d.user instanceof User && d.user.isValid
                        ? (
                            d.user.landingPage
                                ? this.Router.createUrlTree([d.user.landingPage])
                                : this._checked = true
                        )
                        : false
                    ); // next
                    // if (d instanceof AuthenticationRsp && d.user instanceof User)
                }); // subscribe

                return success$.asObservable();
            }
        }

        return false;
    }
}